import TrainingBenefitCallout from './TrainingBenefitCallout.vue';

export default TrainingBenefitCallout;
